module.exports = __webpack_public_path__ + "static/media/banner2.5ca5ec8e.jpg";